<template>
  <div>
      <div class="card-block">
          <b-avatar class="mr-3 mt-2" style="float: left">
              <i class="fas fa-user-tie" style="font-size: 18px"></i>
          </b-avatar>
          <div>
              <strong>{{ $lang.RelationchipManager.Label }}:<br /></strong>
              {{
                objSelected && objSelected.gerenteRelacionamento
                  ? objSelected.gerenteRelacionamento.pessoa.nome
                  : 'NÃO INFORMADO'
              }}
          </div>

          <div align="center" v-if="objSelected && objSelected.historicoGerenteRelacionamento && objSelected.historicoGerenteRelacionamento.length > 0">
              <b-button v-b-toggle.historicoGerenteRelacionamentoAlteracao class="mt-1">Mostrar Alterações</b-button>
              <b-collapse id="historicoGerenteRelacionamentoAlteracao" class="pt-3">
                  <div>
                      <tables
                          ref="tableGrid"
                          :showHeader="false"
                          :columns="['DATA DA ALTERAÇÃO', 'RESPONSÁVEL', 'NOME GERENTE']"
                          :showPaging="false"
                          :showTipFooter="false"
                      >
                          <tr v-for="(alt, index) in objSelected ? objSelected.historicoGerenteRelacionamento : []" :key="index + 'PA'">
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1" :value="alt.dataInicio ? formatDateTimeForms(alt.dataInicio) : ''" />
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1" :value="alt.responsavel" />
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1" :value="alt.funcionario" />
                          </tr>
                      </tables>
                  </div>
              </b-collapse>
          </div>
      </div>
  </div>
</template>

<script>
import AssociatePage from '@/views/private/associate/pages/AssociatePage.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'AssociateGerenteRel',
  components: {
    AssociatePage
  },
  mixins: [ActionsForm],
  props: {
    objSelected: {
      type: Object,
      default: () => ({})
    },
    $lang: {
      type: Object
    }
  },
  mounted () {
    if (this.$refs.tableGrid) {
      this.$emit('send-ref-to-parent', this.$refs.tableGrid)
    }
  },
  methods: {
    formatDateTimeForms (obj) {
      return obj
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateGerenteRel.vue